import fetch from 'isomorphic-fetch';

import ApplicationVersion from './ApplicationVersion';

export default function loadApplicationVersion(): Promise<ApplicationVersion> {
	return fetch('/version.json')
		.then((response) => response.json())
		.then((response) => new ApplicationVersion(response.build));
}
